var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPremium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8509 11H4.1504C3.42369 11 2.83398 10.3279 2.83398 9.49966V2.50034C2.83398 1.6721 3.42369 1 4.1504 1H9.8509C10.5776 1 11.1673 1.6721 11.1673 2.50034V9.49966C11.1673 10.3279 10.5776 11 9.8509 11ZM4.1504 1.74678C3.78705 1.74678 3.49517 2.08622 3.49517 2.49355V9.49287C3.49517 9.90699 3.793 10.2396 4.1504 10.2396H9.8509C10.2143 10.2396 10.5061 9.9002 10.5061 9.49287V2.50034C10.5061 2.08622 10.2083 1.75356 9.8509 1.75356H4.1504V1.74678Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00656 3.5L7.72835 5.21271L9.5 5.40608L8.17454 6.66298L8.54199 8.5L7 7.56077L5.45801 8.5L5.82546 6.66298L4.5 5.40608L6.27165 5.21271L7 3.5H7.00656Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPremium);
export default __webpack_public_path__ + "static/media/ic_premium.8d72039da217b5d178d2833458023955.svg";
export { ForwardRef as ReactComponent };